import { createSlice } from "@reduxjs/toolkit";
import { acceptTermsAndConditionsAPI } from "../../../services/guestUsers/guestUserAllAPIService";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const acceptTermsAndConditionSlice = createSlice({
  name: "acceptTermsAndConditionSlice",
  initialState: data,
  reducers: {
    acceptTermsAndConditionInfo(state) {
      state.isLoading = true;
    },
    acceptTermsAndConditionSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    acceptTermsAndConditionFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    acceptTermsAndConditionReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const acceptTermsAndConditionHandler = (payload) => async (dispatch) => {
  try {
    dispatch(
      acceptTermsAndConditionSliceAction.acceptTermsAndConditionInfo(),
    );
    const response = await acceptTermsAndConditionsAPI(payload);
    dispatch(
      acceptTermsAndConditionSliceAction.acceptTermsAndConditionSuccess(
        response,
      ),
    );
    return response;
  } catch (e) {
    dispatch(
      acceptTermsAndConditionSliceAction.acceptTermsAndConditionFailure(e),
    );
    throw e;
  }
};

export default acceptTermsAndConditionSlice.reducer;
export const acceptTermsAndConditionSliceAction =
  acceptTermsAndConditionSlice.actions;

